import React, { useState } from 'react'
import utils from '../../utils'
import { FaArrowLeftLong } from "react-icons/fa6";
import { useCart } from '../../context/CartContext';
import PaymentOptions from './PaymentOptions';
import toast from 'react-hot-toast';
import paymentsService from '../../services/PaymentServices';
import FormError from '../feedback/FormError';
import { useNavigate } from 'react-router-dom';
import PaymentInfo from './PaymentInfo';
import MpesaPaymentModal from './MpesaModal';

function CompleteCheckout({ cart, numCartItems, setStage, totalPrice }) {
    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)
    const [selectedPayment, setSelectedPayment] = useState('Cash')
    const navigate = useNavigate()

    const { payment, resetCart } = useCart()

    function processPayment() {
        setLoading(true)
        if (selectedPayment !== "Cash") {
            toast.error("Cash Only")
            setLoading(false)
            return
        }
        const data = {
            "payment_method": selectedPayment
        }
        paymentsService.updatePayment(payment?.id, data).then(
            res => {
                if (selectedPayment === "Cash") {
                    paymentsService.confirmPayment(payment?.transaction_reference).then(
                        res => {
                            setLoading(false)
                            toast.success("Payment Confirmed Successfully")
                            resetCart()
                            navigate('/cart/checkout/complete')
                            setLoading(false)
                        },
                        err => {
                            toast.error(utils.toastError + " Confirming Trandsaction")
                            console.log(err);
                            setLoading(false)
                        }
                    )
                }

            },
            err => {
                let errorMessage = 'Something went wrong';

                if (err.response?.status === 400 && Array.isArray(err.response.data?.details)) {
                    const messages = err.response.data.details.map(d => {
                        const fieldName = d.field ? `${d.field.charAt(0).toUpperCase() + d.field.slice(1)}` : 'Field';
                        return `${fieldName}: ${d.message}`;
                    });
                    errorMessage = messages.join('; ') || 'Validation failed';
                } else if (err.response?.status === 400 && err.response.data) {
                    const data = err.response.data;
                    const fieldErrors = Object.entries(data)
                        .flatMap(([field, msgs]) =>
                            (Array.isArray(msgs) ? msgs : [msgs])
                                .filter(msg => typeof msg === 'string')
                                .map(msg => `${field.charAt(0).toUpperCase() + field.slice(1)}: ${msg}`)
                        );
                    errorMessage = fieldErrors.join('; ') || 'Invalid input';
                } else if (err.request) {
                    errorMessage = 'Network error — please check your connection';
                } else {
                    errorMessage = err.message || 'Something went wrong';
                }

                setError(errorMessage)
                toast.error(utils.toastError)
                console.log(err);
                setLoading(false)
            }
        )

    }

    function handleMpesaSuccess() {

    }
    return (
        <div className="flex flex-col lg:flex-row gap-8">
            <div className="w-full lg:w-2/3">
                <p className='mb-6'>Set up your Payment Details.</p>
                {error && (
                    <FormError error={error} />
                )}
                <div className='space-y-5'>
                    <PaymentOptions
                        selectedOption={selectedPayment}
                        onSelect={setSelectedPayment}
                    />
                </div>
            </div>
            <MpesaPaymentModal
                amount={totalPrice}
                onPaymentInitiated={handleMpesaSuccess}
            />
            <div className="w-full lg:w-1/3">
                <div className="bg-white dark:bg-card-dark rounded-xl shadow-md border border-border-light dark:border-border-dark p-6 sticky top-6">
                    <h2 className="text-lg font-bold text-gray-900 dark:text-white border-b border-border-light dark:border-border-dark pb-4 mb-4">
                        Order Summary
                    </h2>

                    <div className="space-y-3 mb-6">
                        <div className="flex justify-between">
                            <span className="text-gray-600 dark:text-gray-400">Subtotal ({numCartItems} item{numCartItems !== 1 ? 's' : ''})</span>
                            <span className="font-medium">KSH {utils.toCommas(payment?.items_total || totalPrice)}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600 dark:text-gray-400">Delivery</span>
                            <span className="font-medium">{payment?.delivery_total || 0}</span>
                        </div>
                        <div className="flex justify-between pt-2 border-t border-border-light dark:border-border-dark">
                            <span className="font-bold text-lg">Total</span>
                            <span className="font-bold text-lg text-secondary">KSH {utils.toCommas(payment?.total || totalPrice)}</span>
                        </div>
                    </div>


                    {selectedPayment === "other" ? (
                        <div>
                            <PaymentInfo
                                loading={loading}
                                setError={setError}
                                setLoading={setLoading}
                            />
                        </div>
                    ) : (
                        <button
                            type="button"
                            onClick={() => {
                                if (selectedPayment === "MPESA") {
                                    const openBtn = document.getElementById("mpesa-open-btn");
                                    if (openBtn) openBtn.click();
                                } else {
                                    processPayment();
                                }
                            }}
                            disabled={loading}
                            className={`w-full font-bold py-3 px-4 rounded-lg text-center transition shadow-md
                                ${loading
                                    ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                    : 'bg-secondary text-white hover:bg-orange-600 cursor-pointer'
                                }`}
                        >
                            {loading ? 'Loading...' : 'Finish Payment'}
                        </button>
                    )}
                    <button
                        onClick={() => setStage(0)}
                        className='btn btn-ghost text-primary w-full mt-2'>
                        <FaArrowLeftLong /> Go Back
                    </button>
                </div>
            </div>
        </div >
    )
}

export default CompleteCheckout